/* eslint-disable no-unused-vars */
import { api } from "@/axios";
import Vue from "vue";
import { decryptData, encryptData } from "../../../utils/helpers";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";
import { deleteCacheByPrefix } from "@/utils/cacheDB";

const state = {
  settings: [],
  lookUpSetting: [],
  singleLookUp: [],
  lookupEndPoints: [],
  permissions: [],
  userRbac: [],
  errorlogs: []
};

const mutations = {
  set_settings(state, val) {
    state.settings = val;
  },
  set_pannel_setting(state, val) {
    state.lookUpSetting = val;
  },
  set_single_pannel_setting(state, val) {
    state.singleLookUp = val;
  },
  set_lookup_endpoints(state, val) {
    state.lookupEndPoints = val;
  },
  set_errorlogs(state, val) {
    state.errorLogs = val;
  },
  set_permissions(state, val) {
    state.permissions = val;
    const userPermissions = {
      userBranch: val[0].branchId,
      permissions: val[0].permissions,
      module_permissions: val[0]?.module_permissions
    };
    const userData = encryptData(
      userPermissions,
      process.env.VUE_APP_SECRET_KEY
    );
    localStorage.setItem("userPermissions", userData);

    const decryptUserData = decryptData(
      localStorage.getItem("userPermissions"),
      process.env.VUE_APP_SECRET_KEY
    );
    state.userRbac = decryptUserData;
  }
};

const actions = {
  async addBussinessSettings({ commit, dispatch, state }, payload) {
    try {
      if (permissionsMiddleWare("Create Business Details")) {
        commit("set_loading", true, { root: true });
        await api.post("/setting", payload);
        await dispatch("settingsList");
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Create Business Details",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async updateSettings({ commit, dispatch, state }, { id, payload }) {
    try {
      commit("set_loading", true, { root: true });
      await api.put(`/setting/${id}`, payload);
      await dispatch("settingsList");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async settingsList({ commit }) {
    if (permissionsMiddleWare("List Business Details")) {
      commit("set_loading", true, { root: true });
      const res = await api.get("/setting");
      commit("set_settings", res.data.result);
      commit("set_loading", false, { root: true });
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : List Business Details",
        { duration: 3000 }
      );
    }
  },
  async branchSettingsList({ commit }, params) {
    if (permissionsMiddleWare("View Branch")) {
      const res = await api.get(`/branch/${params}`);
      commit("set_settings", res.data.result);
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : View Branch",
        { duration: 3000 }
      );
    }
  },
  async updateBranchSettingsList({ commit, state }, { id, payload }) {
    if (permissionsMiddleWare("Update Branch")) {
      try {
        commit("set_loading", true, { root: true });
        await api.post(`/branch/${id}`, payload);
        await deleteCacheByPrefix("branches");
        commit("set_loading", false, { root: true });
        Vue.toasted
          .success("Bussiness settings updated successfully")
          .goAway("3000");
      } catch (error) {
        commit("set_loading", false, { root: true });
      }
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : Update Branch",
        { duration: 3000 }
      );
    }
  },
  async createBranch({ commit, state }, { payload }) {
    try {
      if (permissionsMiddleWare("Create Branch")) {
        commit("set_loading", true, { root: true });
        await api.post(`/branch/`, payload);
        await deleteCacheByPrefix("branches");
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Create Branch",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async editLookUp({ commit }, params) {
    try {
      if (permissionsMiddleWare("View Lookup Setting")) {
        commit("set_loading", true, { root: true });
        const res = await api.get(`/lookupsetting/${params.id}`);
        commit("set_single_pannel_setting", res.data.result);
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : View Lookup Setting",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async getAllLookUps({ commit }, params) {
    try {
      if (permissionsMiddleWare("List Lookup Settngs")) {
        commit("set_loading", true, { root: true });
        const id = `branchId=${params?.id}`;
        const res = await api.get(`/lookupsetting?${params ? id : ""}`);
        commit("set_pannel_setting", res.data.result);
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : List Lookup Settngs",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async createLookUp({ commit, dispatch }, { payload }) {
    try {
      if (permissionsMiddleWare("Create Lookup Setting")) {
        commit("set_loading", true, { root: true });
        await api.post(`/lookupsetting`, payload);
        await dispatch("getAllLookUps");
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Create Lookup Setting",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async updateLookup({ commit, dispatch }, { id, payload }) {
    try {
      commit("set_loading", true, { root: true });
      await api.post(`/lookupsetting?id=${id}`, payload);
      await dispatch("getAllLookUps");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async deletePanelSetting({ commit, dispatch }, { id }) {
    try {
      if (permissionsMiddleWare("Delete Lookup Setting")) {
        commit("set_loading", true, { root: true });
        await api.delete(`/lookupsetting/${id}`);
        await dispatch("getAllLookUps");
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Delete Lookup Setting",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async getEndPoints({ commit }) {
    try {
      commit("set_loading", true, { root: true });
      const res = await api.get(`/lookupsetting/endpoints`);
      commit("set_lookup_endpoints", res.data.result);

      // await dispatch("getAllLookUps");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async createPermissions({ commit }, { payload }) {
    try {
      commit("set_loading", true, { root: true });
      await api.post(`/rbac`, { permissions: payload });

      // await dispatch("getAllLookUps");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async createModulePermissions({ commit }, { payload }) {
    try {
      commit("set_loading", true, { root: true });
      await api.post(`/rbac/create`, { module_permissions: payload });
      // await dispatch("getAllLookUps");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async editPermissions({ commit }, { id, payload }) {
    try {
      commit("set_loading", true, { root: true });
      await api.put(`/rbac/${id}`, { permissions: payload });

      // await dispatch("getAllLookUps");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async editModulePermissions({ commit }, { id, payload }) {
    try {
      commit("set_loading", true, { root: true });
      await api.put(`/rbac/create/${id}`, { module_permissions: payload });

      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async getPermissions({ commit }) {
    try {
      commit("set_loading", true, { root: true });
      const res = await api.get(`/rbac`);
      commit("set_permissions", res.data.result);
      // await dispatch("getAllLookUps");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async getModulePermissions({ commit }) {
    try {
      commit("set_loading", true, { root: true });
      const res = await api.get(`/rbac`);
      commit("set_module_permissions", res.data.result);
      // await dispatch("getAllLookUps");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async getErrorLogs({ commit }) {
    try {
      commit("set_loading", true, { root: true });
      const res = await api.get(`/error/allerror`);
      commit("set_errorlogs", res.data.result);
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async clearAllLogs({ commit, dispatch }, { id }) {
    try {
      commit("set_loading", true, { root: true });
      await api.delete(`/error/clear-logs/${id}`);
      dispatch("getErrorLogs");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  }
};

const getters = {
  settings: state => (state.settings ? state.settings : []),
  lookUpSetting: state => state.lookUpSetting,
  lookupEndPoints: state => state.lookupEndPoints,
  singleLookUp: state => state.singleLookUp,
  rbacPermissions: state => state.permissions,
  userPermissions: state => state.userRbac,
  errorLogs: state => state.errorLogs
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
